import(/* webpackMode: "eager" */ "/codebuild/output/src821806899/src/faculdademetropolitana/src/app/not-found.js");
